import React from "react";
import FooterPagination from "../../../common/FooterPagination";

const ViewLogsFooter = (props) => {
  const { currentPage, totalCount, pageSize, onPageChange } = props;
  return (
    <div className="px-4">
      <FooterPagination
        currentPage={currentPage}
        totalCount={totalCount}
        pageSize={pageSize}
        onPageChange={onPageChange}
      />
    </div>
  );
};

export default ViewLogsFooter;
